var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{class:{
            'required-field': _vm.required,
        },attrs:{"label-for":_vm.inputId}},[_c('label',{class:{
            'urdu-label': _vm.urduLabel,
        }},[_vm._v(_vm._s(_vm.inputLabel))]),_c('b-form-file',_vm._b({ref:"file-input",staticClass:"col-md-10",attrs:{"id":_vm.inputId,"name":_vm.inputName,"disabled":_vm.loading || _vm.disabled},on:{"input":_vm.encrypt}},'b-form-file',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }